import { apiRequest, apiEnabled } from './api';
import { blogPosts as staticPosts } from '../mock';

export { apiEnabled };

// `published`: true = only live, false = only drafts, undefined = all.
export async function fetchAdminBlogPosts(published) {
  if (!apiEnabled) {
    return { items: staticPosts.map((p) => ({ ...p, slug: p.id, published: true })), total: staticPosts.length, source: 'static' };
  }
  const query = {};
  if (published !== undefined) query.published = published;
  const res = await apiRequest('/api/admin/blog', { auth: true, query });
  return {
    items: res.items || [],
    total: res.total || 0,
    publishedCount: res.published_count ?? 0,
    draftCount: res.draft_count ?? 0,
    source: 'api',
  };
}

// Only keys present in the form are sent, so a language left untouched keeps
// whatever is stored (the backend merges i18n dicts key by key).
function cleanI18n(obj, { required = false } = {}) {
  const out = {};
  Object.entries(obj || {}).forEach(([lang, value]) => {
    out[lang] = typeof value === 'string' ? value.trim() : value;
  });
  if (required && !out.es) out.es = '';
  return out;
}

export function toBlogPayload(form) {
  return {
    slug: form.slug.trim(),
    title: cleanI18n(form.title, { required: true }),
    excerpt: cleanI18n(form.excerpt),
    content: cleanI18n(form.content),
    seo_title: cleanI18n(form.seo_title),
    seo_description: cleanI18n(form.seo_description),
    image: (form.image || '').trim(),
    category: (form.category || '').trim(),
    date: (form.date || '').trim(),
    read_time: (form.read_time || '').trim(),
    author: (form.author || '').trim() || 'OWA',
    tags: (form.tags || '')
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean),
    published: Boolean(form.published),
    featured: Boolean(form.featured),
  };
}

export function createBlogPost(payload) {
  return apiRequest('/api/admin/blog', {
    method: 'POST',
    auth: true,
    body: JSON.stringify(payload),
  });
}

export function updateBlogPost(slug, payload) {
  return apiRequest(`/api/admin/blog/${encodeURIComponent(slug)}`, {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(payload),
  });
}

export function deleteBlogPost(slug) {
  return apiRequest(`/api/admin/blog/${encodeURIComponent(slug)}`, {
    method: 'DELETE',
    auth: true,
  });
}
